<!--TeQuick:快捷入口 2021/03/17 11:08:02 YuAng-->

<template>
  <div class="its-te-quick">
    <ul class="its-ul-quick">
      <li class="li-part" v-for="(group, index) in quicks" :key="'quick' + index">
        <p style="height: 40px;line-height: 40px;font-weight: bold">{{ group.title }}</p>
        <ul style="height: calc(100% - 56px)">
          <li class="li-page" v-for="(item, pIndex) in group.items" :key="'page' + pIndex" :class="'row' + group.items.length" :style="{ backgroundImage: 'url(' + require('../../../../assets/images/quick_' + item.id + '.png') + ')' }" data-io-click="tracker" @click="checkJump(item)">
            <div class="li-page-content">
              <p class="li-page-title">{{ item.title }}</p>
              <p class="li-page-subtitle">{{ item.subTitle }}</p>
            </div>
            <span v-show="item.isNew" class="li-page-new">NEW</span>
            <span class="li-page-arrow">→</span>
          </li>
        </ul>
      </li>
    </ul>
    <!-- 是否展示下载引导 -->
    <div v-if="hasDownload" class="its-te-download">
      <p v-html="download.desc"></p>
      <button class="its-base-btn its-primary-btn" @click="downloadClient">
        立即下载体验
      </button>
    </div>
    <!-- 首次进入的下载引导 -->
    <ya-dialog-box :visible.sync="visible" width="746px" full-content top="calc((100vh - 535px) * 0.5)">
      <div class="ts-home-guide">
        <span class="el-icon-close" @click="visible = false"></span>
        <p style="font-size: 22px">老师好，欢迎来到e课堂</p>
        <p style="font-size: 20px">使用e课堂，您可以：</p>
        <ul class="its-ul-guide">
          <li class="navigator" v-for="(guide, index) in guides" :key="'guide' + index">
            <p class="item">
              <img :src=" require('../../../../assets/images/teacher-home-guide' + (index + 1) + '.png')" :width="guide.width" :height="guide.height" />
              <span :style="{marginLeft: guide.left}">{{guide.desc1}}，</span><span style="font-weight: bolder">{{guide.desc2}}</span>
            </p>
          </li>
        </ul>
        <button class="its-base-btn its-primary-btn plain" @click="downloadClient">
          下载{{ download.title }}开始e课堂之旅
        </button>
      </div>
    </ya-dialog-box>
    <!-- 首次进入到期提醒引导 -->
    <ya-dialog-box :visible.sync="overdue" width="600px" full-content top="calc((100vh - 270px) * 0.5)" :fast-close="false" :father-action="overdueAction">
      <div class="ts-overdue-guide">
        <p style="font-size: 18px;text-align: left;margin: 15px 0 38px -80px;font-family: PingFangSC-Medium, sans-serif;">
          亲爱的{{$store.state.user ? $store.state.user.fullName : ""}}老师您好:
        </p>
        <p>
          您的<span style="font-weight: 500">e课堂服务</span>还剩余<span style="color: #f56c6c">{{ product.leftDay }}</span>天，到期后将无法使用
        </p>
        <p>
          请联系校领导或咨询<a style="color: #0083f9" href="https://xkw.sobot.com/chat/pc/v2/index.html?sysnum=c7c900b4c25c4531a6cc9182832cef4c&channelid=5" target="_blank">在线客服</a>，以便继续为您提供服务
        </p>
        <button class="its-base-btn its-primary-btn plain" @click="overdueAction">
          我知道了
        </button>
        <span class="el-icon-close" @click="overdueAction"></span>
      </div>
    </ya-dialog-box>
    <!-- 训练进入前学科选择弹窗 -->
    <div class="its-subject-dialog">
      <ya-dialog-box :visible.sync="dialogItem.visible" width="600px">
        <p slot="title">选择一个学科</p>
        <div style="padding: 0px 8px;margin-top: -12px">
          <group-buttons @click-btn="subjectAction"></group-buttons>
        </div>
      </ya-dialog-box>
    </div>
  </div>
</template>
<script>
import { downloadCenterApi, teacherHomeApi } from "@/utils/api";
import { downloadWithIframe } from "@/utils/download";
import YaDialogBox from "../../../../components/YaDialogBox.vue";
import GroupButtons from './GroupButtons.vue';
export default {
  name: "TeQuick",
  components: { YaDialogBox, GroupButtons },
  props: {
    hasDownload: {
      type: Boolean,
      default: false,
    },
    link: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      visible: false, // 是否下载引导
      overdue: false, // 是否到期引导,
      dialogItem: { visible: false, item: null }, // 是否展示学科选择弹窗
      quicks: [
        {
          title: "课前备课",
          items: [
            {
              title: "在线备课",
              subTitle: "轻松好备课",
              id: "bk",
              isNew: false,
              showSubject: false // 是否展示学科弹窗
            },
            {
              title: "课前预习",
              subTitle: "轻松掌握课前学情",
              id: "preclass",
              isNew: false,
              showSubject: false // 是否展示学科弹窗
            },
          ],
        },
        {
          title: "课后布置",
          items: [
            {
              title: "同步训练",
              subTitle: "紧贴教材,适合同步与单元练习",
              id: "synchronous",
              isNew: false,
              showSubject: true // 是否展示学科弹窗
            },
          ],
        },
        {
          title: "",
          items: [
            {
              title: "阶段训练",
              subTitle: "月考期中期末阶段复习",
              id: "phase",
              isNew: false,
              showSubject: true // 是否展示学科弹窗
            },
            {
              title: "答题卡训练",
              subTitle: "简易作答、快速批改",
              id: "answersheet",
              isNew: false,
              showSubject: true // 是否展示学科弹窗
            },
          ],
        },
      ],
      guides: [
        {
          desc1: '成套精品资源随取随用，在线编辑',
          desc2: '轻松备好课',
          left: '22px',
          width: '20px',
          height: '24px'
        },
        {
          desc1: '丰富学科工具触手可及，多样互动',
          desc2: '高效上好课',
          left: '20px',
          width: '26px',
          height: '24px'
        },
        {
          desc1: '快速布置预习与作业，自动批改',
          desc2: '节省课后时间',
          left: '22px',
          width: '21px',
          height: '22px'
        },
        {
          desc1: '学习数据精准分析，薄弱诊断',
          desc2: '辅助个性化教学',
          left: '21px',
          width: '22px',
          height: '22px'
        }
      ],
      download: {
        identity: "EASY_CLASS_PC",
        title: "e课堂教师电脑端",
        desc: '下载e课堂教师电脑端,成套精品资源随取随用，<span style="font-weight: bolder">轻松备好课</span>；丰富学科工具触手可及，<span style="font-weight: bolder">高效上好课</span>',
      },
    };
  },
  computed: {
    product: function () {
      if (this.$store.state.bigUser.product) {
        return this.$store.state.bigUser.product;
      } else {
        return { name: "--", leftDay: 0 };
      }
    },
  },
  created() {
    this.checkGuide();
  },
  methods: {
    // 到期提醒引导展示检查
    checkOverduGuide: function () {
      teacherHomeApi.checkGuide("ekt-service-expiration-reminder", true, this.product.endDate).then((resp) => {
        const overdue = resp.body && resp.body.display;
        if (overdue) {
          this.overdue = overdue;
        } else {
          this.checkDownloadGuide();
        }
      });
    },
    // 下载客户端按钮展示检查
    checkGuide: function () {
      teacherHomeApi.checkGuide("ekt-index-download-01", true).then((resp) => {
        const needDownload = resp.body && resp.body.display;
        this.$emit("update:hasDownload", needDownload);
      });
      // 检测阶段复习的入口是否展示new
      teacherHomeApi.checkGuide('ekt-training-phase', true).then(resp => {
        this.quicks[2].items[0].isNew = resp.body && resp.body.display
      })
      // 检测答题卡训练的入口是否展示new
      teacherHomeApi.checkGuide('ekt-training-answersheet', true).then(resp => {
        this.quicks[2].items[1].isNew = resp.body && resp.body.display
      })
    },
    // 下载客户端引导展示检查
    checkDownloadGuide: function () {
      teacherHomeApi.checkGuide().then((resp) => {
        this.visible = resp.body && resp.body.display;
      });
    },
    setDownload: function () {
      if (this.product.ektProductEnum === "EKT_HDB") {
        this.download.desc =
          '下载e课堂教师电脑端，丰富学科工具，触手可及，多样课堂互动，<span style="font-weight: bolder">高效上好课</span>';
      }
    },
    downloadClient: function () {
      if (this.download.url) {
        downloadWithIframe(this.download.url);
        return;
      }
      downloadCenterApi.getAppDownload(this.download.identity).then((resp) => {
        if (resp.body && resp.body.length > 0) {
          const app = resp.body[0];
          this.download.url = encodeURI(app.url);
          this.downloadClient();
        }
      });
    },
    overdueAction: function (action) {
      if (action.type === "opened") {
        this.$refs.preview.loadData();
      } else {
        this.overdue = false;
        this.checkDownloadGuide();
        // 就引导出现的次数
        teacherHomeApi.setGuideTime(
          "ekt-service-expiration-reminder",
          this.product.endDate
        );
      }
    },
    subjectAction: function (info) {
      if (info.auto) return
      this.dialogItem.visible = false
      this.dialogItem.item.showSubject = false
      this.jumpNext(this.dialogItem.item)
    },
    checkJump: function (item) {
      if (item.isNew) {
        // 取消引导
        teacherHomeApi.checkGuide('ekt-training-' + item.id).then(resp => {
          if (resp) {
            item.isNew = false
            this.checkJump(item)
          }
        })
        return
      }
      // 如果当前入口需要验证学科
      if (item.showSubject) {
        this.countSubjects(item)
      } else {
        this.jumpNext(item)
      }
    },
    jumpNext: function (item) {
      const url = this.link[item.id]
      if (url) {
        window.open(url, '_self')
      } else {
        this.$message.warning('暂未开放，敬请期待哦')
      }
    },
    countSubjects: async function (item) {
      let count = 0
      const teachInfo = await this.$store.getters.teachInfo
      if (teachInfo) {
        for (let index = 0; index < teachInfo.length; index++) {
          const element = teachInfo[index]
          count = count + element.courses.length
          if (count > 1) break
        }
        this.dialogItem.count = count
        if (count > 1) {
          this.dialogItem.visible = true
          this.dialogItem.item = item
        } else if (count > 0) { 
          this.jumpNext(item)
        } else {
          this.$message.warning('暂无任教，请设置您的任教信息哦')
        }
      } else {
        this.$message.error('您的任教信息出现异常，请联系管理员')
      }
    }
  },
  watch: {
    product: {
      immediate: true,
      handler: function () {
        if (this.product) {
          this.setDownload();
          if (this.product.name !== "--" && this.product.leftDay <= 10) {
            this.checkOverduGuide();
          } else {
            this.checkDownloadGuide();
          }
        } else {
          this.checkDownloadGuide();
        }
      },
    },
  },
};
</script>

<style scoped>
.its-te-quick {
  min-height: 80px;
  background: white;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.its-ul-quick {
  height: 190px;
  padding: 4px 42px 4px 42px;
}

.li-part {
  float: left;
  width: calc((100% - 32px) / 3);
  margin-right: 16px;
  height: 100%;
}

.li-part:last-child {
  margin-right: 0;
}

.li-page {
  height: 100%;
  width: 100%;
  float: left;
  color: white;
  padding-left: 20px;
  position: relative;
  cursor: pointer;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.li-page-title {
  font-weight: bold;
  font-size: 18px;
}

.li-page-content {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
}

.li-page-subtitle {
  display: none;
  font-size: 12px;
}

.li-page-new {
  position: absolute;
  right: -12px;
  top: -8px;
  color: #ff4725;
}

.li-page-arrow {
  position: absolute;
  right: 8px;
  font-weight: bold;
  display: none;
  font-size: 32px;
  bottom: 12px;
  height: 32px;
}

.li-page:hover .li-page-subtitle,
.li-page:hover .li-page-arrow {
  display: inline-block;
}

.li-page.row2 {
  height: calc((100% - 8px) / 2);
  margin-bottom: 8px;
}

.li-page.row2:last-child {
  margin-bottom: 0;
}

.li-page.row2 .li-page-arrow {
  font-size: 22px;
  bottom: 4px;
  height: 22px;
}

.its-te-download {
  text-align: center;
  border-top: 1px solid #e5e5e5;
  padding: 10px 0;
}

.its-te-download button {
  border-radius: 16px;
  margin: 10px 0;
}

.its-te-quick >>> .el-dialog__header,
.its-te-quick >>> .el-dialog__footer {
  display: none;
}

.its-subject-dialog >>> .el-dialog__header {
  display: block;
}

.ts-home-guide {
  width: 100%;
  padding: 34px 44px;
  line-height: 60px;
  font-size: 16px;
  text-align: center;
  position: relative;
  color: black;
}

.ts-home-guide > p {
  text-align: left;
}

.ts-home-guide .item {
  font-size: 17px !important;
}

.ts-home-guide .item span {
  display: inline-block;
  vertical-align: middle;
}

.its-ul-guide {
  width: 100%;
  text-align: center;
  padding: 0 !important;
}

.ts-home-guide .its-base-btn {
  font-size: 20px !important;
  padding: 10px 20px;
  height: 50px;
  margin: 30px 0 20px 0;
  background: #3ca3fd !important;
}

.its-te-quick >>> .ya-dialog-content {
  max-height: 580px;
}

.ts-home-guide .el-icon-close {
  position: absolute;
  right: 20px;
  top: 20px;
  font-size: 18px;
  font-weight: bolder;
  cursor: pointer;
}

.ts-home-guide .el-icon-close:hover {
  opacity: 0.8;
}

.ts-overdue-guide {
  height: 270px;
  margin: 0 calc((100% - 400px) * 0.5);
  padding: 20px 0;
  font-size: 16px;
  text-align: center;
  color: black;
  position: relative;
}

.ts-overdue-guide p {
  margin: 16px 0;
}

.ts-overdue-guide .its-primary-btn {
  padding: 8px 42px;
  height: 40px;
  font-size: 16px;
  margin-top: 16px;
}

.ts-overdue-guide .el-icon-close {
  position: absolute;
  top: 16px;
  right: -84px;
  cursor: pointer;
}
</style>
